<div class="page-data">
    <app-advanced-search (formData)="applyFilters($event)" [config]="filterConfig"> </app-advanced-search>
    <div class="p-relative c-table">
        <app-loader [isLoading]="workTableService.loading()" />
        <app-common-table
            [config]="tableConfig"
            [service]="workTableService"
            (actions)="applyAction($event)"
        >
        </app-common-table>
    </div>
</div>
